'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';
import useSearchNavigation from '@/lib/hooks/useSearchNavigation';
import Tabs from '@/components/ui/Tabs';
import { SearchScope } from '@/lib/enums/searchScope';

export interface ItemTotals {
  [key: string]: number;
}

interface IProps {
  itemTotals: ItemTotals;
  tab: SearchScope;
}

const SearchTabs: React.FC<IProps> = ({ itemTotals, tab }) => {
  const { handleTabChange } = useSearchNavigation();
  const { t } = useTranslation();

  const tabItems = [SearchScope.companies, SearchScope.persons].map((value) => ({
    title: `${t(`components.search.${value}`)} (${itemTotals[value]})`,
    onClick: () => handleTabChange(value),
    active: tab === value,
  }));

  return <Tabs items={tabItems} />;
};

export default SearchTabs;
